import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaRegUserCircle} from "react-icons/fa";
import { RiAdminLine } from "react-icons/ri";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setScrolled(scrollTop > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavLinkClick = () => {
    if (window.innerWidth < 992) {
      // Close menu on small screens
      setIsMenuOpen(false);
      const collapseEl = document.getElementById("navbarNav");
      if (collapseEl.classList.contains("show")) {
        collapseEl.classList.remove("show");
      }
    }
  };

  return (
    <>
      <nav
        className={`navbar navbar-expand-lg fixed-top ${
          scrolled ? "navbar-scrolled" : "navbar-gradian"
        } ${isMenuOpen ? "menu-open" : ""}`}
      >
        <div className="container-fluid">
          <NavLink className="navbar-brand" to="/" title="homePage" onClick={handleNavLinkClick}>
            <img
              src={
                scrolled || isMenuOpen ? "/images/V_gold.png" : "/images/logo_hotel.png"
              }
              className="logo-img"
              alt="Logo"
              title="V Hotel The Grnad Shoba logo"
            />
          </NavLink>

          <button
            className=
            {` ${scrolled || isMenuOpen ?"navbar-toggler":"bg-light navbar-toggler"}`}
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className={` navbar-toggler-icon`}></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
            


          <li className="nav-item" >
                  <NavLink
                    className={`nav-link ${
                      scrolled || isMenuOpen ? "nav-scrolled" : ""
                    }`}
                    to="/"
                    title="Home"
                    onClick={handleNavLinkClick}
                  >
                    HOME
                  </NavLink>
                </li>

                <li className="nav-item" >
                  <NavLink
                    className={`nav-link ${
                      scrolled || isMenuOpen ? "nav-scrolled" : ""
                    }`}
                    to="/corporate"
                    onClick={handleNavLinkClick}
                  >
                    CORPORATE
                  </NavLink>
                </li>
                <li className="nav-item" >
                  <NavLink
                    className={`nav-link ${
                      scrolled || isMenuOpen ? "nav-scrolled" : ""
                    }`}
                    to="/rooms"
                    onClick={handleNavLinkClick}
                  >
                    ROOMS
                  </NavLink>
                </li>
                
               

                <li className="nav-item" >
                  <NavLink
                    className={`nav-link ${
                      scrolled || isMenuOpen ? "nav-scrolled" : ""
                    }`}
                    to="/gallery"
                    onClick={handleNavLinkClick}
                  >
                   GALLERY
                  </NavLink>
                </li>
                   <li className="nav-item" >
                  <NavLink
                    className={`nav-link ${
                      scrolled || isMenuOpen ? "nav-scrolled" : ""
                    }`}
                    to="/blog"
                    onClick={handleNavLinkClick}
                  >
                   BLOG
                  </NavLink>
                </li>


                
                <li className="nav-item" >
                  <NavLink
                    className={`nav-link ${
                      scrolled || isMenuOpen ? "nav-scrolled" : ""
                    }`}
                    to="/dine"
                    onClick={handleNavLinkClick}
                  >
                   DINING
                  </NavLink>
                </li>


              {/* Dining Dropdown */}
              {/* <li className="nav-item dropdown dropdown-hover">
                <NavLink
                  className={`nav-link dropdown-toggle ${
                    scrolled || isMenuOpen ? "nav-scrolled" : ""
                  }`}
                  to="/"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  DINING
                </NavLink>
                <ul className="dropdown-menu">
                  {[
                     { to: "/aero-stag#aerostag", label: "AERO STAG" },
                    { to: "/aero-stag#udaan", label: "UDAAN" },
                    { to: "/aero-stag#safar", label: "SAFAR" },
                    { to: "/aero-stag#zaika", label: "ZAIKA" }
                  ].map((item, index) => (
                    <li key={index}>
                      <Link className="dropdown-item" to={item.to} onClick={handleNavLinkClick}>
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li> */}
 <li className="nav-item" >
                  <NavLink
                    className={`nav-link ${
                      scrolled || isMenuOpen ? "nav-scrolled" : ""
                    }`}
                    to="/contact-us"
                    onClick={handleNavLinkClick}
                  >
                   CONTACT 
                  </NavLink>
                </li>

              {
                localStorage.getItem("login")?(localStorage.getItem("role")==="@A*_s&_k!=!@h!-%"?
              
                <li className="nav-item" >
                <NavLink
                  className={`nav-link ${
                    scrolled || isMenuOpen ? "nav-scrolled" : ""
                  }`}
                  to="/my-account"
                  onClick={handleNavLinkClick}
                >
               <RiAdminLine /> ADMIN
               
                </NavLink>
                
                </li>
              :
               <li className="nav-item" >
              <NavLink
                className={`nav-link ${
                  scrolled || isMenuOpen ? "nav-scrolled" : ""
                }`}
                to="/my-account"
                onClick={handleNavLinkClick}
              >
             <FaRegUserCircle /> MY ACCOUNT
             
              </NavLink>
              
              </li>
              )
                :
                <li className="nav-item" >
                  <NavLink
                    className={`nav-link ${
                      scrolled || isMenuOpen ? "nav-scrolled" : ""
                    }`}
                    to="/signin"
                    onClick={handleNavLinkClick}
                  >
                  LOGIN
                  </NavLink>
                </li>
              }

              {/* Book a Stay Button */}
              <li className="nav-item">
                <Link to="/booking" title="V hotel The Grand Shoba Booking ">
                  <button
                    className="btn"
                    style={{
                      backgroundColor: "#AD8B3A",
                      color: "white",
                      fontFamily: "sans-serif,Inter",
                    }}
                    onClick={handleNavLinkClick}
                  >
                    BOOK
                  </button>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
